import styled from 'styled-components';
import { select } from '../../../core/themev2';

const SelectorContainer = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 8px;
  border: 1px solid ${select('neutralDarkGray')};
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: ${({ justifyContent }) => justifyContent};
  position: absolute;
  top: ${({ upPosition, topUp, topDown }) => (upPosition ? topUp : topDown)};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  box-shadow: 0px 4px 11px 9px rgba(166, 166, 166, 0.05);
  z-index: 8;
  padding: ${({ padding }) => padding};
`;

const Header = styled.div`
  font-family: Hind;
  text-align: left;
  cursor: auto;
  .containerHeader {
    padding: 8px 16px;
    .title {
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      line-height: normal;
      white-space: normal;
      color: ${({ colorTitle }) => select(colorTitle)};
    }
    .textInfo {
      margin-top: 4px;
      font-size: 12px;
      font-weight: 400;
      font-style: normal;
      line-height: normal;
      white-space: normal;
    }
  }
  .separator {
    width: 100%;
    height: 1px;
    background-color: ${select('neutralDarkGray')};
    margin: 8px 0;
  }
`;

const PostingsOption = styled.div`
  height: 42px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  :hover {
    background-color: ${select('neutralGray')};
    cursor: pointer;
  }
  > img {
    margin-right: 8px;
  }
  span {
    color: ${({ colorSpan }) => colorSpan};
  }
`;

const LoaderWrapper = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 8;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { SelectorContainer, PostingsOption, Header, LoaderWrapper };
